// PnL Calculation Constants
export const PNL_CONSTANTS = {
    // Base amount for PnL percentage calculation (500 million VND)
    BASE_AMOUNT: 500000000,
} as const;

// Helper function to calculate PnL percentage
export const calculatePnLPercentage = (increasedAmount: number, total=PNL_CONSTANTS.BASE_AMOUNT): number => {
    return (increasedAmount / total) * 100;
};
